module.exports = __webpack_public_path__ + "024dacbb6328b518274251936757abf5.png";